import { Leaf, Flower2, Heart, Sun } from "lucide-react";
import { PILLARS } from "@/data";
import { Reveal } from "@/components/Reveal";

const ICONS = { Leaf, Flower2, Heart, Sun };

export const Pillars = () => (
  <section className="bg-brand-paper border-y border-brand-gold/15 grain">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-brand-gold/15">
      {PILLARS.map((p, i) => {
        const Icon = ICONS[p.icon];
        return (
          <Reveal key={p.title} delay={i * 0.08} className="flex items-center gap-4 px-2 md:px-8 py-5 md:py-2">
            <span className="text-brand-sage shrink-0"><Icon size={30} strokeWidth={1.4} /></span>
            <div>
              <p className="eyebrow !text-brand-forest !tracking-[0.22em]">{p.title}</p>
              <p className="font-body text-brand-inkSoft text-sm mt-1">{p.sub}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);
